import { useEffect, useRef } from "react";
import Message from "./Message";

const Messages = ({ messages, lookalike, conversationId, fetchInfluencer, campaign }) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  }, [messages]);

  if (messages.length === 0 || !campaign) return null;

  return (
    <div className="overflow-y-scroll h-[calc(100vh-13rem)] sm:h-[calc(100vh-12rem)]">
      <div className="max-w-4xl mx-auto p-4 lg:p-6 space-y-6">
        {messages.map((msg, index) =>
          <Message
            key={index}
            msg={msg}
            index={index}
            lookalike={lookalike}
            conversationId={conversationId}
            fetchInfluencer={fetchInfluencer}
            campaign={campaign}
          />
        )}
        <div ref={messagesEndRef} />
      </div>
    </div>
  )
}

export default Messages;